import { AdminMessage } from "@components/admin/admin-helpers"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { SlideTimerIndicator } from "@components/atoms/SlideTimerIndicator"
import { AutoCarousel } from "@components/media/AutoCarousel"
import { LargeCard } from "@components/patterns/LargeCard"
import { Chip, chipStyles } from "@components/ui/Chip"
import { useSlideTimer } from "@hooks/useSliderTimer"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Large Program Strand Card",
  description: "A large card for featuring a program strand",
  category: "embed",
  tags: ["#featured"],
  flags: {
    fullWidth: true,
    marginRule: "featured-card",
  },
}

export default defineBlock("hero/large-strand-card", (props) => {
  const strands = props.strands?.filter(Boolean)
  if (!strands?.length) {
    if (env.admin) {
      return <AdminMessage>Please select a strand</AdminMessage>
    }
    return null
  }

  const timer = useSlideTimer({ total: strands.length, slideDuration: 6 })
  const strand = strands[timer.current]

  return (
    <Link
      href={strand?.uri}
      className="block w-grid mx-auto"
      data-mixpanel-block="Large Program Strand Card"
      data-mixpanel-strand={strand?.title}
    >
      <LargeCard
        widget={timer.total > 1 && <SlideTimerIndicator timer={timer} />}
        theme={props.cardColour ?? "orange"}
        title={<div className="type-title-l">{strand?.title}</div>}
        description={
          <div className="h-[5em] line-clamp-3 md:h-auto md:line-clamp-none">
            <EditableText store="description" defaultValue={strand?.excerpt} />
          </div>
        }
        media={
          <div className="aspect-video md:aspect-auto bg-black md:absolute md:inset-0">
            <AutoCarousel
              aspect={16 / 9}
              speed={0.1}
              items={
                strand?.images?.map((img) => (
                  <div className="flex pr-3 h-full">
                    <ResponsiveImage srcSet={img.srcSet} objectFit="cover" className="w-full h-full" />
                  </div>
                ))!
              }
            />
          </div>
        }
        animationKey={strand?.uri!}
        layout="auto"
        infoWidth="lg"
        height="md"
        tags={[
          <Chip>Program Strand</Chip>,
          strand?.info?.category?.name && <Chip>{strand?.info?.category?.name}</Chip>,
          <EditableText
            store="extraBadge"
            placeholder="Optional extra badge"
            plainText
            as="span"
            className={chipStyles().base()}
          />,
        ]}
      />
    </Link>
  )
})
